<template>
  <div class="sceneContainer">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.sceneContainer{
  height: 100%;
}
</style>
